module.exports = __webpack_public_path__ + "static/img/9.3ff96686.jpg";